import { ACCESS_NAME } from "helpers/constant";
import { ACCESS_MODE } from "helpers/constant";
import { ACCESS_TOKEN } from "helpers/constant";
import React, { createContext, useState, useContext } from "react";

const AuthContext = createContext(undefined);

export const AuthProvider = ({ children }) => {
  const [isLoggedIn, setIsLoggedIn] = useState(
    !!localStorage.getItem(ACCESS_TOKEN)
  );

  const login = (dataUser) => {
    const { token, name, mode } = dataUser;
    localStorage.setItem(ACCESS_TOKEN, token);
    localStorage.setItem(ACCESS_NAME, name);
    localStorage.setItem(ACCESS_MODE, mode);
    setIsLoggedIn(true);
  };

  const logout = () => {
    localStorage.removeItem(ACCESS_TOKEN);
    localStorage.removeItem(ACCESS_NAME);
    localStorage.removeItem(ACCESS_MODE);
    setIsLoggedIn(false);
  };

  const value = { isLoggedIn, login, logout };

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (context === undefined) {
    throw new Error("useAuth must be used within an AuthProvider");
  }
  return context;
};
